import { breakpoints } from "@gigpro/ui/utils/useBreakpoint";
import { CssBaseline, createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material";
import GlobalStyles from "@mui/material/GlobalStyles";
import { StyledEngineProvider } from "@mui/material/styles";
import type React from "react";
import components from "./components";
import palette from "./palette";
import shadows from "./shadows";
import typography from "./typography";

export const theme = createTheme({
  cssVariables: true,
  spacing: 5,
  palette,
  typography,
  components: components as any,
  shadows,
  breakpoints: { values: breakpoints },
});

export const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <StyledEngineProvider enableCssLayer>
        <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
        <CssBaseline />
        {children}
      </StyledEngineProvider>
    </MuiThemeProvider>
  );
};
